import { render, staticRenderFns } from "./main-menu-grouping-mobile.vue?vue&type=template&id=1d224c83&"
import script from "./main-menu-grouping-mobile.vue?vue&type=script&lang=ts&"
export * from "./main-menu-grouping-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./main-menu-grouping-mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports